import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Copyright from '../../internals/components/Copyright';
import TransitionMark from '../../../Transitions/TransitionMark';
import NotFoundDisplay from './NotFoundDisplay';

export default function MainGridNotFound({ category }) {
    return (
        <>
            <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, display: 'flex', flexDirection: 'column' }}>
                <Grid
                    container
                    spacing={2}
                    columns={12}
                    sx={{ mb: (theme) => theme.spacing(2), alignItems: 'center', justifyContent: 'center' }}
                >
                    <NotFoundDisplay
                        imageUrl="images/not-found.jpg"
                        imageAlt="not found 404"
                    />
                </Grid>
                <Copyright sx={{ my: 4 }} />
            </Box>
        </>
    );

};